$(document).ready(function () {
  var card = [
    {
      title: "Merry Christmas!",
      image:
        "https://cdn.shopify.com/s/files/1/0447/7327/7855/files/MimosaBox_Merry_Christmas.jpg?v=1603942739",
    },
    {
      title: "Congrats!",
      image:
        "https://cdn.shopify.com/s/files/1/0447/7327/7855/files/MimosaBox_Postcards_Congrats_7cad54db-8f53-46eb-a526-5fc3ec2eed3f.jpg?v=1601403841",
    },
    {
      title: "Get Well Soon",
      image:
        "https://cdn.shopify.com/s/files/1/0447/7327/7855/files/MimosaBox_Postcards_GetWellSoon-web_d8751617-2e1a-4432-af2f-ea18c7b80604.jpg?v=1601491981",
    },
    {
      title: "Happy Birthday! (white)",
      image:
        "https://cdn.shopify.com/s/files/1/0447/7327/7855/files/MimosaBox_Postcards_HappyBirthday3.jpg?v=1601404554",
    },
    {
      title: "Happy Birthday! (Green)",
      image:
        "https://cdn.shopify.com/s/files/1/0447/7327/7855/files/MimosaBox_Postcards_HappyBirthday2-web_4ab37122-ab01-4f88-8cb4-25acd91c9774.jpg?v=1601492228",
    },
    {
      title: "Happy Birthday! (Pink)",
      image:
        "https://cdn.shopify.com/s/files/1/0447/7327/7855/files/MimosaBox_Postcards_HappyBirthday-web_884d484f-119a-43d6-98da-205f073e891a.jpg?v=1601491657",
    },
    {
      title: "Be My Bridesmaid",
      image:
        "https://cdn.shopify.com/s/files/1/0447/7327/7855/files/MimosaBox_Postcards_Bridesmaid-web_64527abd-dd5f-47ac-97e4-31e06c0f6741.jpg?v=1601491900",
    },
    {
      title: "Thank You",
      image:
        "https://cdn.shopify.com/s/files/1/0447/7327/7855/files/MimosaBox_Postcards_ThankYou_fa31d37e-66d9-4aa9-99ad-bd87608afcf4.jpg?v=1601405054",
    },
    {
      title: "Enjoy",
      image:
        "https://cdn.shopify.com/s/files/1/0447/7327/7855/files/MimosaBox_Postcards_Enjoy.jpg?v=1601607021",
    },
    {
      title: "Thinking Of You",
      image:
        "https://cdn.shopify.com/s/files/1/0447/7327/7855/files/MimosaBox_Postcards_ThinkingOfYou_8ca0767f-b775-4168-84f7-658c3ecedaf4.jpg?v=1601405244",
    },
  ];
  var message =
    "Choose the perfect card for the occasion. Don't forget to leave your note, so our team will handwrite it to make your gifts personal.";
  $(".step-description p").html("");
  $(".step-description p").html(message);
  var liscards = "";
  $.each(card, function (k, v) {
    liscards +=
      ' <li data-title="' +
      card[k].title +
      '" data-image="' +
      card[k].image +
      '"><a href="#"><div class="card-image"><img src="' +
      card[k].image +
      '"><i class="selected-icon fa fa-check-circle" aria-hidden="true"></i></div>';
    liscards += '<div class="card-title">' + card[k].title + "</div></a></li>";
  });
  $("ul.card-options-list").html("");
  $("ul.card-options-list").html(liscards);
  $(document).on("click", "ul.card-options-list li", function (e) {
    e.preventDefault();
    var titlev = $(this).data("title");
    var imagev = $(this).data("image");
    $('[name="properties[Card]"]').val(titlev);
    $(this).siblings().removeClass("selected");
    $(this).addClass("selected");
    $(".mfp-close").click();
    $("#cuadro").removeClass("acard");
    $("#cuadro").addClass("picked-card");
    $("#cuadro").html("");
    var newhtml = '<img class="card-image" src="' + imagev + '">';
    newhtml +=
      '<div class="card-info"><div class="title ">' +
      titlev +
      '</div><div class="subtitle">(change card)</div></div>';
    $("#cuadro").html(newhtml);
  });

  //Messagex

  var $control = $("textarea#Messagex"),
    $remaining = $("#remaining"),
    textLimit = parseInt($control.attr("maxlength"), 10);

  var currentLength = $control.val().length;
  if (currentLength === 0) {
    $remaining.text("Please write down your personalization");
  } else {
    var firstremaining = textLimit - currentLength;
    var firstremainingtext =
      "You have " + firstremaining + " characters remaining";
    $remaining.text(firstremainingtext);
  }

  $control.on("keyup paste", function () {
    $control.val($control.val().substring(0, textLimit));

    var currentValLength = $control.val().length;
    if (currentValLength === 0) {
      $remaining.text("Please write down your personalization");
    } else {
      var numberremaining = textLimit - currentValLength;
      var textremaining =
        "You have " + numberremaining + " characters remaining";
      if (numberremaining > 0) {
        $remaining.text(textremaining);
      } else {
        $remaining.text("YOU HAVE REACHED THE MAXIMUM AMOUNT OF CHARACTERS");
      }
    }
  });

  function addDays(days) {
    var result = new Date();
    result.setDate(result.getDate() + days);
    return result;
  }
  var daysMore = 2; //disable days more of actual date
  var disabledDays = [0, 6]; // Make Sunday and Saturday disabled
  var newMinDate = addDays(daysMore);
  if ($("#deliverydate").length) {
    // use this if you are using id to check
    $("#deliverydate").datepicker({
      language: "en",
      autoClose: true,
      minDate: newMinDate, //
      onRenderCell: function (date, cellType) {
        if (cellType == "day") {
          var day = date.getDay(),
            isDisabled = disabledDays.indexOf(day) != -1;

          return {
            disabled: isDisabled,
          };
        }
      },
    });
  }
});
